<template>
  <div class="position-relative ">
    <div class="container pt-5" style="margin-top:100px">
      <div class="row ">
        <div class="col-md-12 text-center mb-5">
          <h1 class="display-1">Got a question?</h1>
          <h3 class="lead">We'd like to talk more about what you need</h3>
          <!-- <button class="btn btn-icon btn-primary mt-3" type="button">
                                <span class="btn-inner--icon"><i class="ni ni-chat-round"></i></span>
                                <span class="btn-inner--text">Chat with us</span>
                            </button> -->
        </div>
      </div>
      <div class="row contactus-3">
        <div class="col-lg-4 col-md-4 col-6 col-sm-12 col-border-cont ">
          <div class="info info-hover">
            <div
              class="icon icon-shape icon-shape-primary icon-lg shadow rounded-circle text-primary"
            >
              <i class="ni ni-square-pin"></i>
            </div>
            <h4 class="info-title">Address</h4>
            <p class="description px-0">
              201 Spear St, Suite 1100 <br />San Francisco, CA 94105
            </p>
            <p class="description px-0"></p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-6 col-sm-12 col-border-cont">
          <div class="info info-hover">
            <div
              class="icon icon-shape icon-shape-primary icon-lg shadow rounded-circle text-primary"
            >
              <i class="ni ni-email-83"></i>
            </div>
            <h4 class="info-title">Email</h4>
            <p class="description px-0">
              <a href="mailto:sales@universal-teck.com" target="_blank"
                >sales@universal-teck.com</a
              >
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-6 col-sm-12">
          <div class="info info-hover">
            <div
              class="icon icon-shape icon-shape-primary icon-lg shadow rounded-circle text-primary"
            >
              <i class="ni ni-mobile-button"></i>
            </div>
            <h4 class="info-title">Phone</h4>
            <p class="description px-0">
              <a href="tel:1-888-886-4775">+1 (888) 886-4775</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="container-fluid">
        <div class="row mt-2 mb-4 pt-5">
          <div class="col-md-7 ml-auto mr-auto text-center mt-5">
            <!-- <span class="badge badge-info">Leave a message</span> -->
            <h1 class="title">We would love to hear from you</h1>
            <h4 class="desc" style="line-height:2;">
              If you have inquiries or want to learn more about Universal Tech,
              please contact us by completing the form below.
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mx-auto ">
            <EmailForm></EmailForm>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EmailForm from "./components/EmailForm";

export default {
  created() {},
  components: {
    EmailForm,
  },
  methods: {},
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}

.info {
  max-width: 360px;
  margin: 0 auto;
  padding: 1.5rem;
  text-align: center;
  border-radius: 0.25rem;
  transition: all 0.5s;
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .col-border-cont {
    border-right: 1px solid #f2f2f2;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .col-border-cont {
    border-right: 1px solid #f2f2f2;
  }
}
</style>
